<template>
    <BaseCard>
        <template #header>
            <LaCsvDownload :csv-data="yieldCsvData" :filename="filename" />
        </template>
        <template v-if="!yieldLoading">
            <div class="columns">
                <div class="column">
                    <PublishersRevenueStackedBarChart v-if="yieldData.length" :earnings-csv-data="yieldData" />
                    <PublishersImpressionsStackedBarChart v-if="yieldData.length" :earnings-csv-data="yieldData" />
                </div>
            </div>

            <div style="margin-top: 2rem">
                <LaMultiPublisherYieldTable :data="yieldCsvData" />
            </div>
        </template>
        <LaDataCardLoader v-else :chart-count="2" :chart-height="500" />
    </BaseCard>
</template>

<script>
import BaseCard from "@/components/BaseCard";
import LaDataCardLoader from "@/components/loaders/DataCardLoader";
import LaMultiPublisherYieldTable from "@/components/multiPublisher/MultiPublisherYieldTable.vue";
import PublishersRevenueStackedBarChart from "@/components/charts/PublishersRevenueStackedBarChart.vue";
import PublishersImpressionsStackedBarChart from "@/components/charts/PublishersImpressionsStackedBarChart.vue";
import LaCsvDownload from "@/components/CsvDownload.vue";

export default {
    name: "LaMultiPublisherYieldDataCard",
    components: {
        LaCsvDownload,
        BaseCard,
        LaDataCardLoader,
        LaMultiPublisherYieldTable,
        PublishersRevenueStackedBarChart,
        PublishersImpressionsStackedBarChart,
    },
    props: {
        yieldLoading: {
            type: Boolean,
        },
        yieldMetadata: {
            type: Object,
            required: true,
        },
        yieldData: {
            type: Array,
            required: true,
        },
        yieldCsvData: {
            type: Array,
            required: true,
        },
        publishers: {
            type: Array,
            required: true,
        },
    },
    computed: {
        filename() {
            return `multi_publisher_yield_%from>%to`;
        },
    },
};
</script>
